window.pmtEnv = PMTENV;

window.addEventListener('error', function (event) {
	var knownErrors = [
		'domNode is undefined',
		"Cannot read properties of undefined (reading 'elm_event_node_ref')"
	];
	if (!event.error) {
		return;
	}
	var isAKnownError = knownErrors.indexOf(event.error.message) !== -1;
	if (isAKnownError) {
		document.getElementById('browserError').style.display = 'block';
	}
});

const revision = REVISION,
	flags = PMTENV,
	serviceName = 'Login';

require('@pinmeto/ui/dist/pmt-instrumentation');
window.PinMeToInstrumentation.init(`${serviceName}.frontend`, revision, flags);

const login = window.localStorage && window.localStorage.getItem('login.route');
const { Elm } = require('../Main.elm');
const app = Elm.Main.init({ flags: { route: login || '', env: window.pmtEnv?.env || 'dev' } });

PinMeToLogger.init(window.PinMeToInstrumentation.log);

app.ports.pinMeToLoggerLog && app.ports.pinMeToLoggerLog.subscribe(PinMeToLogger.log);
app.ports.otpEnableUpdateDropDownScrollIntoView.subscribe(dropDownScroll);
app.ports.out_Main_setDefaultLoginRoute.subscribe(setDefaultLoginRoute);

function dropDownScroll(id) {
	var e = document.getElementById(id);

	if (e != null) {
		var p = e.parentElement || { scrollTop: 0, offsetHeight: 0 };
		if (e.offsetTop - p.scrollTop < 0) {
			e.scrollIntoView(true);
		} else if (e.offsetTop + e.offsetHeight - p.scrollTop > p.offsetHeight) {
			e.scrollIntoView(false);
		}
	}
}

function setDefaultLoginRoute({ route = '' }) {
	window.localStorage && window.localStorage.setItem('login.route', route);
}
